<template>
  <div
    class="db-modal-confirmation-container"
    :class="{ 'db-has-illustration': $slots.illustration }"
  >
    <div
      v-if="$slots.illustration"
      class="db-illustration"
    >
      <slot name="illustration" />
    </div>
    <div class="db-modal-confirmation-content">
      <p
        class="db-title db-text-center db-title-1"
        aria-hidden="true"
      >
        <slot name="title" />
      </p>
      <p class="db-description db-text-center">
        <slot />
      </p>
      <div class="db-modal-buttons">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>

<style>
@import '@/assets/styles/components/modals/_modal-confirmation.css';
</style>
